/* eslint-disable */
import { mapState, mapActions } from 'vuex';
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { SelectedSiteIdMixin } from './SelectedSiteIdMixin'

export const BookingPortalImageCacheMixin = {
    mixins: [SelectedSiteIdMixin],
    data() {
        return {
            error: ''
        }
    },
    computed: {
        ...mapState('BookingPortalImage', [
            'fetchedBookingPortalImage',
            'fetchingBookingPortalImage',
            'attempted',
            'bookingPortalImage'
        ])
    },
    methods: {
        ...mapActions('BookingPortalImage', [
            'fetchBookingPortalImage'
        ]),
        refreshBookingPortalImage() {
            if (!this.fetchedBookingPortalImage && !this.fetchingBookingPortalImage) {
                this.tryFetchBookingPortalImage();
            }
        },
        tryFetchBookingPortalImage() {
            const self = this;
            self.error = '';
            if(self.attempted){
                return;
            }
            self.fetchBookingPortalImage({ siteId: self.selectedSiteId })
                .catch(error => self.error = ErrorHelper.getError(error));
        }
    },
    created() {
        this.refreshBookingPortalImage();
    }
}
